import { UI_PRIMITIVE__label } from '@/components/ui/label';
import { UI_PRIMITIVE__radio_group } from '@/components/ui/radio_group/UI_PRIMITIVE__radio_group';
import { UI_PRIMITIVE__radio_group_item } from '@/components/ui/radio_group/UI_PRIMITIVE__radio_group_item';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';

export function RADIO__image_select_context() {
  /*
   * STORE
   */

  const dispatch = use_dispatch();

  const { g_image_edit__replace__workspace_id, g_image_edit__field, g_general__ui_disabled } = use_slice_ui([
    'g_image_edit__replace__workspace_id',
    'g_image_edit__field',
    'g_general__ui_disabled',
  ]);
  const { workspace_current } = use_slice_workspace(['workspace_current']);

  /*
   * EVENTS
   */

  function onValueChange(value: string) {
    dispatch(LOCAL__ui_set_string({ key: 'g_image_edit__replace__workspace_id', value, valid_values: [] }));
  }

  /*
   * RENDERS
   */
  function render_item(workspace_id: string, label: string) {
    let id = `workspace_${workspace_id}`;

    return (
      <div className="flex items-center space-x-2 cursor-pointer w-full">
        <UI_PRIMITIVE__radio_group_item value={workspace_id} id={id} />
        <UI_PRIMITIVE__label htmlFor={id} className="cursor-pointer" size="xs" variant="bar">
          {label}
        </UI_PRIMITIVE__label>
      </div>
    );
  }

  /*
   * HTML
   */

  if (workspace_current.is_stub()) return null;
  if (g_image_edit__field.is_stub()) return <PLACEHOLDER_bar_line />;

  return (
    <div className="flex flex-col w-full gap-1">
      <div className="text-sm text-bar-foreground">Area to search</div>
      <UI_PRIMITIVE__radio_group className="w-full" {...{ onValueChange }} value={g_image_edit__replace__workspace_id} disabled={g_general__ui_disabled}>
        {render_item(workspace_current._id, 'This workspace')}
        {render_item(ENUM__string_id_empty.OBJECT_ID, 'All Images')}
      </UI_PRIMITIVE__radio_group>
    </div>
  );
}
